import { render, staticRenderFns } from "./ProductInventory.vue?vue&type=template&id=15c69059"
import script from "./ProductInventory.vue?vue&type=script&lang=js"
export * from "./ProductInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports